import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DonutChart from "../utils/graphs/DonutChart";
import LineChart from "../utils/graphs/LineChart";
import PerformanceGrid from "../utils/graphs/PerformanceGrid";
import UserLayout from "../utils/user/UserLayout";
import { connect } from "react-redux";
import { fetchAnalyticsAction } from "../../redux/actions/analytics/analyticsAction";
import { fetchDashboardAction } from "../../redux/actions/dashboard/dashboardAction";
import NewPayment from "../dashboard/NewPayment";
import { Modal } from "react-bootstrap";
import "../../assets/css/app.css";
// import asset5 from "../../
import asset2 from "../../assets/images/icon/asset2.png";
import new_shape_1 from "../../assets/images/new_shape_1.png";
import new_shape3 from "../../assets/images/new_shape3.png";
import shap3 from "../../assets/images/shap3.png";
import new_shape2 from "../../assets/images/new_shape2.png";
import asset6 from "../../assets/images/icon/asset6.png";
import hexagongeometricalshapeoutline from "../../assets/images/hexagon-geometrical-shape-outline.png";
import asset7 from "../../assets/images/icon/asset7.png";
import asset9 from "../../assets/images/icon/asset9.png";
import asset8 from "../../assets/images/icon/asset8.png";
import map from "../../assets/images/map.png";
import "../../assets/custome.css";
import LineChartPro from "../utils/graphs/LIneChartPro";
import DonutTest from "../utils/graphs/DonutTest";
import "../../assets/custome.css";
import DonutPro from "../utils/graphs/DonutPro";
import PerformanceColumn from "../utils/graphs/PerformanceColumn";
import PerformanceColumnSmall from "../utils/graphs/PerformanceColumnSmall";
import SystemExpHalf from "../utils/graphs/SystemExpHalf";
import MyContactsLocation from "../network/MyContactsLocation";
import ReactTooltip from "react-tooltip";
import { fetchMyContactsLocationMapAction } from "../../redux/actions/network/networkAction";
import DonutProRefe from "../utils/graphs/DonutProRefe";
import DonutProMain from "../utils/graphs/DonutProMain";
import DashboardStats from "../dashboard/DashboardStats";
import QueryString from "query-string";
import { updatePaidAction } from "../../redux/actions/user/userAction";
import ProfileStatus from "../dashboard/ProfileStatus";
import ProfileStatusPro from "../dashboard/ProfileStatusPro";
import ReactLoading from "react-loading";
import { red } from "@material-ui/core/colors";
import Loader from "../network/helper/CV/Loader";
export const ProfileAnalytics = (props) => {
  // console.log(props);
  const getColor = (condition) => {
    if (condition === "HIGHER") {
      return "#fbc809";
    } else if (condition === "AVERAGE") {
      return "#2BB4B0";
    } else if (condition === "LOWER") {
      return "#d3eaf3";
    } else {
      // Default color when none of the conditions match
      return "";
    }
  };
  // console.log(props);
  const [data, setData] = useState([0, 0, 0, 0]);
  const [peerData, setPeerData] = useState([0, 0, 0, 0]);

  const [content, setContent] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function addSuffixToNumber(number) {
    const suffixes = ["th", "st", "nd", "rd"];
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return number + "th";
    }

    const lastDigit = number % 10;
    return (
      <span>
        {number}
        <sup>{suffixes[lastDigit] || "th"}</sup>
      </span>
    );
  }

  const [networkStatus, setNetworkStatus] = useState({
    value: 75,
    text: "",
    bgcolor: "#2F9CCA",
    type: "",
    isDisplayVal: true,
  });
  const [userRanking, setUserRanking] = useState({
    value: 0,
    outOf: 0,
    text: "",
    bgcolor: "#93AEC7",
    type: "",
    isDisplayVal: true,
  });
  const [myProfileIssued, setMyProfileIssued] = useState({
    value: 0,
    text: "",
    bgcolor: "#2F9CCA",
    type: "",
    isDisplayVal: true,
  });
  const [myNetworkStatus, setMyNetworkStatus] = useState({
    value: 0,
    text: "",
    bgcolor: "#2BB4B0",
    type: "",
    isDisplayVal: true,
  });
  const [reference, setReference] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  const [primaryJobTitle, setPrimaryJobTitle] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  const [experience, setExperience] = useState({
    value: 0,
    text: "",
    bgcolor: "#2BB4B0",
    type: "",
    isDisplayVal: true,
  });
  const [overallScore, setOverallScore] = useState({
    value: 0,
    text: "",
    bgcolor: "red",
    type: "",
    isDisplayVal: true,
  });

  const [coursesTraining, setCoursesTraining] = useState({
    value: 0,
    text: "",
    bgcolor: "#d3eaf3",
    type: "",
    isDisplayVal: true,
  });
  const [qualification, setQualification] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  const [systems, setSystems] = useState({
    value: 0,
    text: "",
    bgcolor: "#fbc809",
    type: "",
    isDisplayVal: true,
  });
  const [competences, setCompetences] = useState({
    value: 0,
    text: "",
    bgcolor: "#d3eaf3",
    type: "",
    isDisplayVal: true,
  });
  const [network, setNetwork] = useState({
    value: 0,
    text: "weak",
    bgcolor: "#d3eaf3",
    type: "",
    isDisplayVal: false,
  });

  const [profile, setProfile] = useState({
    value: 0,
    text: "complete",
    bgcolor: "#d3eaf3",
    type: "%",
    isDisplayVal: true,
  });

  const [peerSeries, setPeerSeries] = useState([
    ["Primary Job ", 0],
    ["Experience", 0],
    ["Qualifications", 0],
    ["Training", 0],
    ["Systems", 0],
    ["Competencies", 0],
  ]);
  const [series, setSeries] = useState([
    ["Primary Job ", 0],
    ["Experience", 0],
    ["Qualifications", 0],
    ["Training", 0],
    ["Systems", 0],
    ["Competencies", 0],
  ]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // props.fetchDashboard();
    // props.fetchAnalytics();
    if (
      Object.keys(props.analytics).length > 0 &&
      Object.keys(props.dashboard).length > 0
    ) {
      // Set your state variables here...

      setIsLoading(false); // Update loading state once data is fetched
    }
    if (Object.keys(props.profile).length > 0) {
      setProfile((prevState) => ({
        ...prevState,
        value: props?.profile?.profile_fill,
      }));

      setCoursesTraining((prevState) => ({
        ...prevState,
        value: props?.dashboard?.user_training_pro,
      }));

      setSystems((prevState) => ({
        ...prevState,
        value: props?.dashboard?.user_systems_score_pro,
      }));
      setCompetences((prevState) => ({
        ...prevState,
        value: props?.dashboard?.user_competencies_score_pro,
      }));

      setOverallScore((prevState) => ({
        ...prevState,
        value: props?.profile?.profile_score,
      }));
      setMyProfileIssued((prevState) => ({
        ...prevState,
        value: props?.dashboard?.my_profile_issued,
        // ? 0
        // : props?.dashboard?.my_profile_issued,
      }));
      setMyNetworkStatus((prevState) => ({
        ...prevState,
        value: props?.dashboard?.my_network_status,
        // ? 0
        // : props?.dashboard?.my_profile_issued,
      }));
      setExperience((prevState) => ({
        ...prevState,
        // value: props?.dashboard?.user_experience_score,
        value: props?.dashboard?.user_experience_score_pro,
      }));
      setQualification((prevState) => ({
        ...prevState,
        value: props?.dashboard?.user_qualification_score_pro,
      }));
      // setCoursesTraining((prevState) => ({
      //   ...prevState,
      //   value: props?.analytics?.statutory_industry_score,
      // }));
      // setQualification((prevState) => ({
      //   ...prevState,
      //   value: props?.analytics?.qualification_score,
      // }));
      setReference((prevState) => ({
        ...prevState,
        value: props?.dashboard?.pro_total_received_references,
      }));
    }
    if (props?.dashboard?.user_profile_score_pro !== undefined) {
      setUserRanking((prevState) => ({
        ...prevState,
        // value: props?.dashboard?.user_ranking,
        value: props?.dashboard?.user_profile_score_pro,
        // outOf: props?.dashboard?.PEER_Group_Overall_count,
      }));
    }

    setPrimaryJobTitle((prevState) => ({
      ...prevState,
      // value: props.dashboard.primary_job_title_years_experience,
      value: props?.dashboard?.user_primary_jobTitle_pro,
    }));
    setData([
      props?.dashboard?.user_experience_score,
      props?.analytics?.qualification_score,
      props?.analytics?.statutory_industry_score,
      props?.analytics?.systems_score,
    ]);
    setPeerData([
      props?.dashboard?.average_peer_experience_score,
      props?.dashboard?.average_peer_qualification_score,
      props?.dashboard?.average_peer_training_score,
      props?.dashboard?.average_peer_systems_score,
    ]);

    if (Object.keys(props.dashboard).length === 0) {
      props.fetchDashboard();
    }

    if (Object.keys(props.analytics).length === 0) {
      props.fetchAnalytics();
    }

    if (
      Object.keys(props.analytics).length > 0 &&
      Object.keys(props.dashboard).length > 0
    ) {
      setSeries([
        ["Primary Job ", props.dashboard.primary_job_title_years_experience],
        ["Experience", props.dashboard.user_experience_score],
        ["Qualifications", props.analytics.qualification_score],
        ["Training", props.analytics.statutory_industry_score],
        ["Systems", props.analytics.systems_score],
        ["Competencies", props.analytics.competencies_score],
      ]);
      setPeerSeries([
        ["Primary Job ", props.dashboard.maximum_primary_jobTitle],
        ["Experience", props.dashboard.maximum_experience_score],
        ["Qualifications", props.dashboard.maimum_qualification_score],
        ["Training", props.dashboard.maximum_traning_score],
        ["Systems", props.dashboard.maximum_systems_score],
        ["Competencies", props.dashboard.maximum_competencies_score],
      ]);
    }
  }, [props]);

  const [paid, setPaid] = useState(props.user && props.user.is_paid);
  const location = useLocation();
  const values = QueryString.parse(location.search);
  const [loading, setLoading] = useState(false);
  if (values.successful === "true") {
    setLoading(true);
    const updatePaidData = {
      id: props.user.id,
    };

    props
      .updatePaid(props.user && props.user.id)
      .then((response) => {
        console.log("API Response:", response);
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setLoading(false); 
      });
  }
  return (
    <>
      {paid ? (
        <div className="profile-analytics">
          <UserLayout>
            {isLoading ? (
              // <div className="loader-container">
                // <ReactLoading color={"#203d75"} width={"5%"} id="loader-container"/>
                <Loader />
              // </div>
            ) : (
              <div className="home-page">
                <div className="content-wrapper">
                  <div className="container">
                    <div className="main-content">
                      <div className="row">
                        <div
                          className="col-lg-12"
                          style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                          <div  className="banner" style={isMobile ? { marginLeft: "-29px" } : {}}>
                            <div className="banner-title-overlay">
                              <h5>
                                <span>
                                  {/* MY */}
                                  <br />
                                  <img
                                    src="\assets\images\banners\goneetProText.png"
                                    alt=""
                                    style={{
                                      height: isMobile ? "19px":"50px",
                                      width: "auto",
                                      marginLeft: "20px",
                                    }}
                                  />
                                  {/* <sub> <img src="\assets\images\banners\goneetText.png" alt="goneet" style={{height:'30px',width:'auto',}}/></sub>&nbsp;<span style={{background:'white',color:'#DD572B',borderRadius:'4px'}}>PRO</span> */}
                                  <hr className="bannerhr"
                                    style={{
                                      height: "5px",
                                      background: "white",
                                      width: "45%",
                                      marginLeft: "20px",
                                    }}
                                  />
                                </span>
                              </h5>
                              <img
                                src="\assets\images\icons\asset2.png"
                                className="icon-image "
                              />
                            </div>

                            <img
                              className="banner-image"
                              src="\assets\images\banner-pro.png"
                              alt="Not Found"
                              style={{
                                marginLeft: "30px",
                                paddingRight: "30px",
                              }}
                            />
                          </div>

                          <div
                            className="dash-content"
                            // style={{ paddingLeft: "30px" }}
                          >
                            &nbsp;
                            <h6 className="section-title">
                              MY<b> Rankings :</b>{" "}
                              {props?.dashboard?.primary_job}
                            </h6>
                            <div className="bg-section">
                              {/* <div className="your-score">
                                <div className="row">
                                  <div className="col-xl-9">
                                    <div className="row gx-2 gx-lg-4 po-rl">
                                      <div className="col-sm-6 mb-2">
                                        <div className="score-card">
                                          <div className="shap-image">
                                            <img src={new_shape_1} width={280} />
                                          </div>
                                          <div className="score-content">
                                            <div className="title">
                                              <h6>PEER Group Overall Total</h6>
                                            </div>
                                            <div className="score">
                                              <b
                                                className="text-light"
                                                style={{ fontSize: "70px" }}
                                              >
                                                {
                                                  props?.dashboard
                                                    ?.PEER_Group_Overall_count
                                                }
                                              </b>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <div className="score-card top-right">
                                          <div className="shap-image">
                                            <img src={new_shape3} width={280} />
                                          </div>
                                          <div className="score-content">
                                            <div className="title">
                                              <h6>
                                                MY Network <br />
                                                PEER Group Ranking
                                              </h6>
                                            </div>
                                            <div className="score">
                                              <b
                                                className="text-light"
                                                style={{ fontSize: "60px" }}
                                              >
                                                {
                                                  props?.dashboard
                                                    ?.my_network_ranking
                                                }
                                              </b>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-12 score-progress-main">
                                        <div
                                          className="circular-progress"
                                          data-progress-color="white"
                                          data-bg-color="white"
                                          id="pro-donut"
                                        >
                                          <DonutPro data={userRanking} />
                                          <div className="inner-circle" />
                                          <div className="percentage-main">
                                            <span
                                              className="percentage "
                                              style={{ fontSize: "70px" }}
                                            >
                                              {props?.dashboard?.user_ranking ===
                                              undefined
                                                ? 0
                                                : props?.dashboard?.user_ranking}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="col-sm-6"
                                        style={{ paddingTop: "40px" }}
                                      >
                                        <div className="score-card">
                                          <div className="shap-image">
                                            <img src={shap3} width={280} />
                                          </div>
                                          <div className="score-content">
                                            <div className="title">
                                              <h6>MY Profile Status</h6>
                                            </div>
                                            <div className="score">
                                              <b
                                                style={{
                                                  color: "#fbc809",
                                                  fontSize: "60px",
                                                }}
                                              >
                                                {
                                                  props?.dashboard
                                                    ?.my_profile_status
                                                }
                                              </b>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="col-sm-6 mt-2 mt-sm-0"
                                        style={{ paddingTop: "40px" }}
                                      >
                                        <div className="score-card bottom-right score-content">
                                          <div className="shap-image">
                                            <img src={new_shape2} width={280} />
                                          </div>
                                          <div className="score-content">
                                            <div className="title">
                                              <h6>
                                                MY Network
                                                <br />
                                                PEER Group Leader
                                              </h6>
                                            </div>
                                            <div className="score">
                                              <b
                                                className="text-light"
                                                style={{ fontSize: "60px" }}
                                              >
                                                {
                                                  props?.dashboard
                                                    ?.my_network_peer_group_leader
                                                }
                                              </b>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-3 bl mt-2 mt-xl-0 my-profile-box">
                                    <div className="row g-2">
                                      <div className="col-6 col-xl-12  ">
                                        <div
                                          className="right-score-card top graph-block-row1"
                                          style={
                                            {
                                              // height: "230px",
                                              // paddingTop: "35px",
                                            }
                                          }
                                        >
                                          <h6 style={{ fontSize: "15px" }}>
                                            My <span> Profile(s) Issued</span>
                                          </h6>
                                          <div className="score-progress-bar-card orange score-content">
                                            <div className="circular-progress graph-block">
                                              <DonutProMain
                                                data={myProfileIssued}
                                                total={
                                                  props?.dashboard
                                                    ?.total_profile_issued
                                                }
                                              />
                                            </div>
                                            <p style={{ fontSize: "13px" }}>
                                              PEER Group Averages
                                            </p>
                                            <div
                                              className="score-btn"
                                              style={{ color: "#fbc809" }}
                                            >
                                              {props?.dashboard
                                                ?.average_profile_issued ===
                                              undefined
                                                ? 0
                                                : props?.dashboard
                                                    ?.average_profile_issued}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-6 col-xl-12 mt-3 my-network-box">
                                        <div
                                          className="right-score-card bottom graph-block-row1"
                                          style={
                                            {
                                              // height: "230px",
                                              // paddingTop: "35px",
                                            }
                                          }
                                        >
                                          <h6 style={{ fontSize: "15px" }}>
                                            My <span> Network Status</span>
                                          </h6>
                                          <div className="score-progress-bar-card orange">
                                            <div className="circular-progress ">
                                              <DonutProMain
                                                data={myNetworkStatus}
                                                total={
                                                  props?.dashboard
                                                    ?.total_network_status
                                                }
                                              />
                                            </div>
                                            <p style={{ fontSize: "13px" }}>
                                              PEER Group Averages
                                            </p>
                                            <div
                                              className="score-btn"
                                              style={{ color: "#fbc809" }}
                                            >
                                              {props?.dashboard
                                                ?.average_network_status ===
                                              undefined
                                                ? 0
                                                : props?.dashboard
                                                    ?.average_network_status}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              <div className="top-section ">
                                <div className="row">
                                  <div className="col-md-8 content-left">
                                    <div className="row ">
                                      <img src={new_shape_1} alt="" />
                                      <span className="content-title">
                                        {" "}
                                        <h2>PEER Group Overall Total</h2>
                                        <div className="score">
                                          <b
                                            className="text-light group-title"
                                            // style={{ fontSize: "70px" }}
                                          >
                                            {
                                              props?.dashboard
                                                ?.PEER_Group_Overall_count
                                            }
                                          </b>
                                        </div>
                                      </span>

                                      <img src={new_shape3} alt="" />
                                      <span className="content-title2">
                                        {" "}
                                        <h2>
                                          {" "}
                                          <small>MY</small> Profile Status
                                        </h2>
                                        <div className="score">
                                          <b
                                            className="group-title"
                                            style={{
                                              color: "#fbc809",
                                              // fontSize: "60px",
                                            }}
                                          >
                                            {
                                              props?.dashboard
                                                ?.my_profile_status
                                            }
                                          </b>
                                        </div>
                                      </span>
                                      <img src={shap3} alt="" />
                                      <span className="content-title3">
                                        {" "}
                                        <h2>
                                          <small>MY</small> Network <br />
                                          PEER Group Ranking
                                        </h2>
                                        <div className="score">
                                          <b
                                            className="text-light group-title"
                                            // style={{ fontSize: "60px" }}
                                          >
                                            {addSuffixToNumber(
                                              props?.dashboard
                                                ?.my_network_ranking
                                            )}
                                          </b>
                                        </div>
                                      </span>
                                      <img src={new_shape2} alt="" />
                                      <span className="content-title4">
                                        {" "}
                                        <h2>
                                          <small>MY</small> Network
                                          <br />
                                          PEER Group Leader
                                        </h2>
                                        <div className="score">
                                          <b
                                            className="text-light group-title"
                                            // style={{ fontSize: "60px" }}
                                          >
                                            {addSuffixToNumber(
                                              props?.dashboard
                                                ?.my_network_peer_group_leader
                                            )}
                                          </b>
                                        </div>
                                      </span>
                                    </div>
                                    <div className="center-donut">
                                      <DonutPro data={userRanking} />
                                      <span className="centered-text">
                                        <b
                                          style={{
                                            color: "#FBC809",
                                            fontSize: isMobile ? "35px" : "60px",
                                            fontFamily: "",
                                          }}
                                        >
                                          {addSuffixToNumber(
                                            props?.dashboard?.user_ranking
                                          )}
                                        </b>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="vl" style={{display: isMobile ? "none" : "block"}}></div>
                                  <div className="col-md-3 col-lg-3 bl mt-0 mt-xl-0 my-profile-box" style={isMobile ? {paddingRight: "7px"}: {}}>
                                    <img
                                      src="\assets\images\squareBox2.png"
                                      alt=""
                                    />
                                    <span className="content-title p-2">
                                      {" "}
                                      <h2>
                                        {" "}
                                        <small>MY</small>{" "}
                                        <span> Profile Issued</span>
                                      </h2>
                                      <div className="donut">
                                        <DonutProMain
                                          data={myProfileIssued}
                                          total={
                                            props?.dashboard
                                              ?.total_profile_issued
                                          }
                                        />
                                      </div>
                                      <div className="donut-title">
                                        <p>PEER Group Averages</p>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: "#fbc809",
                                          border: "1px solid #fbc809",
                                          // textAlign: "center",
                                          // width: "45%",
                                          borderRadius: "3px",
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.average_network_status === undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.average_network_status}
                                      </div>
                                    </span>
                                    <div className="profile-cont">
                                      <img
                                        src="\assets\images\squareBox2.png"
                                        alt=""
                                      />
                                      <span className="content-title1 p-2">
                                        {" "}
                                        <h2>
                                          {" "}
                                          <small>MY</small>{" "}
                                          <span> Network Status</span>
                                        </h2>
                                        <div className="donut">
                                          <DonutProMain
                                            data={myNetworkStatus}
                                            total={
                                              props?.dashboard
                                                ?.total_network_status
                                            }
                                          />
                                        </div>
                                        <div className="donut-title">
                                          <p>PEER Group Averages</p>
                                        </div>
                                        <div
                                          className="score-btn"
                                          style={{
                                            color: "#fbc809",
                                            border: "1px solid #fbc809",
                                            textAlign: "center",
                                            // width: "45%",
                                            borderRadius: "3px",
                                          }}
                                        >
                                          {props?.dashboard
                                            ?.average_network_status ===
                                          undefined
                                            ? 0
                                            : props?.dashboard
                                                ?.average_network_status}
                                        </div>
                                      </span>
                                    </div>

                                    {/* <img src={shap3} alt="" /> */}
                                  </div>
                                </div>
                              </div>
                              <div className="profile-score">
                                <h3
                                  className="title"
                                  style={{ fontSize: "14px" }}
                                >
                                  <small style={{ fontSize: "14px" }}>MY</small>{" "}
                                  <b>Profile Score</b> v's
                                  <b> Maximum Available Score</b>
                                </h3>
                                {/* <canvas id="lineChart" /> */}
                                <LineChartPro
                                  data={series}
                                  data2={peerSeries}
                                />
                              </div>

                              <div className="score-progress-bar graph-block-row2">
                                <h3
                                  className="title"
                                  style={{ fontSize: "14px" }}
                                >
                                  <small style={{ fontSize: "14px" }}>MY</small>{" "}
                                  <b>Scores</b> v's <b>PEER Group Averages</b>
                                </h3>
                                <div className="row gy-3">
                                  <div className="col-6 col-sm-4 col-md-3 col-xl-2">
                                    <div className="score-progress-bar-card orange">
                                      <div className="graph-block circular-progress">
                                        <DonutTest
                                          data={primaryJobTitle}
                                          maximum={
                                            props?.dashboard
                                              ?.user_primary_jobTitle_pro
                                          }
                                          label={
                                            props?.dashboard
                                              ?.primary_jobTitle_label
                                          }
                                        />
                                        <div className="percentage-main">
                                          <span
                                            className=" "
                                            style={{
                                              fontSize: "25px",
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              color: getColor(
                                                props?.dashboard
                                                  ?.primary_jobTitle_label
                                              ),
                                            }}
                                          >
                                            {
                                              props?.dashboard
                                                ?.primary_job_title_years_experience
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: getColor(
                                            props?.dashboard
                                              ?.primary_jobTitle_label
                                          ),
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.avg_primary_jobTitle === undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.avg_primary_jobTitle}
                                      </div>
                                      <p>PRIMARY JOB </p>
                                    </div>
                                  </div>
                                  <div className="col-6 col-sm-4 col-md-3 col-xl-2">
                                    <div className="score-progress-bar-card orange">
                                      <div className="graph-block  circular-progress">
                                        <DonutTest
                                          data={experience}
                                          maximum={
                                            props?.dashboard
                                              ?.maximum_experience_score
                                          }
                                          label={
                                            props?.dashboard?.experience_label
                                          }
                                        />
                                        <div className="percentage-main">
                                          <span
                                            className=" "
                                            style={{
                                              fontSize: "25px",
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              color: getColor(
                                                props?.dashboard
                                                  ?.experience_label
                                              ),
                                            }}
                                          >
                                            {
                                              props?.dashboard
                                                ?.user_experience_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: getColor(
                                            props?.dashboard?.experience_label
                                          ),
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.average_experience_score ===
                                        undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.average_experience_score}
                                      </div>
                                      <p>EXPERIENCE</p>
                                    </div>
                                  </div>
                                  <div className="col-6 col-sm-4 col-md-3 col-xl-2">
                                    <div className="score-progress-bar-card orange">
                                      <div className="graph-block  circular-progress">
                                        <DonutTest
                                          data={qualification}
                                          maximum={
                                            props?.dashboard
                                              ?.maimum_qualification_score
                                          }
                                          label={
                                            props?.dashboard
                                              ?.qualification_label
                                          }
                                        />
                                        <div className="percentage-main">
                                          <span
                                            className=" "
                                            style={{
                                              fontSize: "25px",
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              color: getColor(
                                                props?.dashboard
                                                  ?.qualification_label
                                              ),
                                            }}
                                          >
                                            {
                                              props?.analytics
                                                ?.qualification_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: getColor(
                                            props?.dashboard
                                              ?.qualification_label
                                          ),
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.average_qualification_score ===
                                        undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.average_qualification_score}
                                      </div>
                                      <p>QUALIFICATION</p>
                                    </div>
                                  </div>
                                  <div className="col-6 col-sm-4 col-md-3 col-xl-2">
                                    <div className="score-progress-bar-card orange">
                                      <div className="graph-block  circular-progress">
                                        <DonutTest
                                          data={coursesTraining}
                                          maximum={
                                            props?.dashboard
                                              ?.maximum_traning_score
                                          }
                                          label={
                                            props?.dashboard?.training_label
                                          }
                                        />
                                        <div className="percentage-main">
                                          <span
                                            className=" "
                                            style={{
                                              fontSize: "25px",
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              color: getColor(
                                                props?.dashboard?.training_label
                                              ),
                                            }}
                                          >
                                            {
                                              props?.analytics
                                                ?.statutory_industry_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: getColor(
                                            props?.dashboard?.training_label
                                          ),
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.average_statutory_industry_score ===
                                        undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.average_statutory_industry_score}
                                      </div>
                                      <p>TRAINING</p>
                                    </div>
                                  </div>
                                  <div className="col-6 col-sm-4 col-md-3 col-xl-2">
                                    <div className="score-progress-bar-card orange">
                                      <div className="graph-block  circular-progress">
                                        <DonutTest
                                          data={systems}
                                          maximum={
                                            props?.dashboard
                                              ?.maximum_systems_score
                                          }
                                          label={
                                            props?.dashboard?.systems_label
                                          }
                                        />
                                        <div className="percentage-main">
                                          <span
                                            className=" "
                                            style={{
                                              fontSize: "25px",
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              color: getColor(
                                                props?.dashboard?.systems_label
                                              ),
                                            }}
                                          >
                                            {props?.analytics?.systems_score}
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: getColor(
                                            props?.dashboard?.systems_label
                                          ),
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.average_systems_score === undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.average_systems_score}
                                      </div>
                                      <p>SYSTEMS</p>
                                    </div>
                                  </div>
                                  <div className="col-6 col-sm-4 col-md-3 col-xl-2">
                                    <div className="score-progress-bar-card orange">
                                      <div className="graph-block  circular-progress">
                                        <DonutTest
                                          data={competences}
                                          maximum={
                                            props?.dashboard
                                              ?.maximum_competencies_score
                                          }
                                          label={
                                            props?.dashboard?.competencies_label
                                          }
                                        />
                                        <div className="percentage-main">
                                          <span
                                            className=" "
                                            style={{
                                              fontSize: "25px",
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              color: getColor(
                                                props?.dashboard
                                                  ?.competencies_label
                                              ),
                                            }}
                                          >
                                            {
                                              props?.analytics
                                                ?.competencies_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        className="score-btn"
                                        style={{
                                          color: getColor(
                                            props?.dashboard?.competencies_label
                                          ),
                                        }}
                                      >
                                        {props?.dashboard
                                          ?.average_skills_score === undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.average_skills_score}
                                      </div>
                                      <p>COMPETENCIES</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="bottom-cards">
                                <div className="row g-3">
                                  <div className="col-md-6 col-xl-4  mb-4">
                                    <ProfileStatusPro
                                      agencies={
                                        props?.dashboard?.total_agency_count ===
                                        undefined
                                          ? 0
                                          : props?.dashboard?.total_agency_count
                                      }
                                      companies={
                                        props?.dashboard
                                          ?.total_company_count === undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.total_company_count
                                      }
                                      organisations={
                                        props?.dashboard
                                          ?.total_organization_count ===
                                        undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.total_organization_count
                                      }
                                      individual={
                                        props?.dashboard
                                          ?.total_individual_count === undefined
                                          ? 0
                                          : props?.dashboard
                                              ?.total_individual_count
                                      }
                                    />
                                    {/* <div className="profile-status card-border">
                                      <h6 className="title">My Profile Status</h6>
                                      <div className="row gy-3">
                                        <div className="col-6">
                                          <div className="profile-status-card">
                                            <div className="card-head p-3">
                                              <div className="icon">
                                                <img
                                                  src={asset6}
                                                  alt="Not Found"
                                                  style={{
                                                    height: "65px",
                                                    width: "auto",
                                                  }}
                                                />
                                                <h6 
                                                // style={{ fontSize: "15px" }}
                                                >
                                                  Agencies
                                                </h6>
                                              </div>
                                              <div className="status">
                                                <img
                                                  src={
                                                    hexagongeometricalshapeoutline
                                                  }
                                                  width={35}
                                                  alt="Not Found"
                                                />
                                                {
                                                  props?.dashboard
                                                    ?.total_agency_count
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="profile-status-card">
                                            <div className="card-head p-3">
                                              <div className="icon">
                                                <img
                                                  src={asset7}
                                                  alt="Not Found"
                                                  style={{
                                                    height: "65px",
                                                    width: "auto",
                                                  }}
                                                />
                                                <h6 
                                                // style={{ fontSize: "15px" }}
                                                >
                                                  Companies
                                                </h6>
                                              </div>
                                              <div className="status">
                                                <img
                                                  src={
                                                    hexagongeometricalshapeoutline
                                                  }
                                                  width={35}
                                                  alt="Not Found"
                                                />
                                                {
                                                  props?.dashboard
                                                    ?.total_company_count
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="profile-status-card">
                                            <div className="card-head p-3">
                                              <div className="icon">
                                                <img
                                                  src={asset9}
                                                  alt="Not Found"
                                                  style={{
                                                    height: "65px",
                                                    width: "auto",
                                                  }}
                                                />
                                                <h6 
                                                // style={{ fontSize: "15px" }}
                                                >
                                                  Organisations
                                                </h6>
                                              </div>
                                              <div className="status">
                                                <img
                                                  src={
                                                    hexagongeometricalshapeoutline
                                                  }
                                                  width={35}
                                                  alt="Not Found"
                                                />
                                                {
                                                  props?.dashboard
                                                    ?.total_organization_count
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="profile-status-card">
                                            <div className="card-head p-3">
                                              <div className="icon">
                                                <img
                                                  src={asset8}
                                                  alt="Not Found"
                                                  style={{
                                                    height: "65px",
                                                    width: "auto",
                                                  }}
                                                />
                                                <h6 
                                                // style={{ fontSize: "15px" }}
                                                >
                                                  Individuals
                                                </h6>
                                              </div>
                                              <div className="status">
                                                <img
                                                  src={
                                                    hexagongeometricalshapeoutline
                                                  }
                                                  width={35}
                                                  alt="Not Found"
                                                />
                                                {
                                                  props?.dashboard
                                                    ?.total_individual_count
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                                  </div>
                                  <div className="col-md-6 col-xl-4  mb-4">
                                    <div
                                      className="network card-border"
                                      style={{ maxHeight: "300px" }}
                                    >
                                      {/* <h6 className="title">
                                        My Network Location
                                      </h6> */}
                                      {/* <div className="image"> */}

                                      <MyContactsLocation
                                        markers={props?.locationMap}
                                        setTooltipContent={setContent}
                                      />
                                      {/* <ReactTooltip>{content}</ReactTooltip> */}
                                    </div>

                                    {/* </div> */}
                                  </div>
                                  <div className="col-md-6 col-xl-4  mb-4">
                                    <div
                                      className="network-peers card-border"
                                      style={{ maxHeight: "300px" }}
                                    >
                                      {/* <h6 className="title">
                                        My Network Location
                                      </h6> */}
                                      {/* <div className="image"> */}
                                      <h6
                                        className="title"
                                        style={{ fontSize: "14px" }}
                                      >
                                        MY<strong> Score</strong>v’s MY{" "}
                                        <strong> Network PEERs</strong>
                                      </h6>
                                      <PerformanceColumn
                                        peersData={peerData}
                                        data={data}
                                        height={250}
                                        color={"white"}
                                      />
                                    </div>

                                    {/* </div> */}
                                  </div>

                                  <div className="col-md-6 col-xl-4" style={ isMobile ? {paddingBottom: "20px"} : {} }>
                                    <div className="experience card-border">
                                      <h6 className="title">
                                        {" "}
                                        MY <b>Systems Experience</b>{" "}
                                      </h6>
                                      <SystemExpHalf
                                        data={
                                          props?.dashboard
                                            ?.user_systems_score === undefined
                                            ? 0
                                            : props?.dashboard
                                                ?.user_systems_score
                                        }
                                        color={"white"}
                                      />
                                      {/* <div className="meter">
                                        <div className="meter-bar">
                                          <div className="mask">
                                            <div className="semi-circle" />
                                            <div className="semi-circle--mask" />
                                          </div>
                                          <svg
                                            width={30}
                                            height={100}
                                            id="needle"
                                            viewBox="0 0 30 144"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{
                                              transform:
                                                "rotate(-19deg) translateX(-50%)",
                                            }}
                                          >
                                            <circle
                                              cx="15.2089"
                                              cy="128.608"
                                              r="10.9086"
                                              fill="#4370a9"
                                              stroke="#f59e1d"
                                              strokeWidth={7}
                                            />
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M17.3486 0.920656L25.3277 127.679L25.3166 127.679C25.322 127.833 25.3239 127.988 25.322 128.144C25.2587 133.535 20.8377 137.853 15.4474 137.79C10.0571 137.726 5.73875 133.305 5.80203 127.915C5.80386 127.759 5.80934 127.604 5.81838 127.45L5.80766 127.45L17.3486 0.920656ZM19.2238 134.487C22.4036 132.316 23.2212 127.978 21.0498 124.798C18.8784 121.618 14.5404 120.801 11.3606 122.972C8.18076 125.144 7.36323 129.482 9.53459 132.661C11.706 135.841 16.044 136.659 19.2238 134.487Z"
                                              fill="#fff"
                                            />
                                            <defs>
                                              <linearGradient
                                                id="paint0_linear_498_1180"
                                                x1="8.57715"
                                                y1="129.079"
                                                x2="18.8019"
                                                y2="129.199"
                                                gradientUnits="userSpaceOnUse"
                                              >
                                                <stop
                                                  offset="0.6874"
                                                  stopColor="#3F4142"
                                                />
                                                <stop
                                                  offset="0.6875"
                                                  stopColor="#2C2C2C"
                                                />
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                        </div>
                                        <div className="text">
                                          <p className="Weak">Weak</p>
                                          <p className="Storng">Strong</p>
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                  <div className="col-md-6 col-xl-4" style={ isMobile ? {paddingBottom: "20px"} : {} }>
                                    <div className="network-status card-border">
                                      <h6 className="title ">
                                        MY <strong> Network Status</strong>
                                      </h6>
                                      <div className="row gy-3">
                                        <div className="col-6 p-2">
                                          <div className="network-status-card blue">
                                            <h6>
                                              {props?.dashboard
                                                ?.total_users_network ===
                                              undefined
                                                ? 0
                                                : props?.dashboard
                                                    ?.total_users_network}
                                            </h6>
                                            <p>MY Network Total</p>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div
                                            className="network-status-card red"
                                            style={{ marginTop: "9px" }}
                                          >
                                            <h6>
                                              {" "}
                                              {props?.dashboard
                                                ?.no_of_users_primary ===
                                              undefined
                                                ? 0
                                                : props?.dashboard
                                                    ?.no_of_users_primary}
                                            </h6>
                                            <p>Primary Job </p>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="network-status-card orange">
                                            <h6>
                                              {props?.dashboard
                                                ?.no_of_users_secondary ===
                                              undefined
                                                ? 0
                                                : props?.dashboard
                                                    ?.no_of_users_secondary}
                                            </h6>
                                            <p>Secondary Job </p>
                                          </div>
                                        </div>
                                        <div
                                          className="col-6"
                                          style={{ marginTop: "2px" }}
                                        >
                                          <div className="network-status-card green">
                                            <h6>
                                              {" "}
                                              {props?.dashboard
                                                ?.no_of_users_seeking_employment ===
                                              undefined
                                                ? 0
                                                : props?.dashboard
                                                    ?.no_of_users_seeking_employment}
                                            </h6>
                                            <p>Seeking Employment</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6 col-xl-4">
                                    <div className="references card-border  graph-block-row2">
                                      <h6 className="title">
                                        MY <strong>References</strong>{" "}
                                      </h6>
                                      <div className="row">
                                        <div
                                          className="col-md-4 circular-progress text-center "
                                          // style={{ marginBottom: "10px" }}
                                          style={{ marginBottom: isMobile ? "-10px" : "10px" }}
                                        >
                                          <DonutProRefe data={reference} />
                                          {/* <div className="inner-circle" /> */}
                                        </div>

                                        <div className="col-md-8">
                                          <h6
                                            className="mt-5 text-light"
                                            style={{ fontSize: "16px" }}
                                          >
                                            References
                                            <br /> Received
                                          </h6>
                                        </div>
                                      </div>
                                      {/* <div className="references-progress-bar">
                                        <div className="reference-donut">
                                        </div>
                                      </div> */}
                                      <div className="bottom-process-bar">
                                        <p style={{ fontSize: "20px" }}>
                                          {reference.value === undefined
                                            ? 0
                                            : reference.value}
                                          %
                                        </p>
                                        <div className="progress">
                                          <div
                                            className="progress-bar"
                                            style={{
                                              width: `${reference.value}%`,
                                              backgroundColor: "",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mt-5" 
                            style={{
                                  display: isMobile ? "none" : "block"
                                }}>
                              <div className="col-12" id="pro-navigation">
                                <ul className="quick-links ">
                                  <li>
                                    <div className="here-menu">
                                      <label>YOUR HERE</label>
                                      <img
                                        src="/assets/images/downround-icon.png"
                                        alt=""
                                      />
                                    </div>
                                    <Link to="">
                                      <span className="icon-wrap">
                                        <img
                                          src="\assets\images\quick-links\profile.svg"
                                          alt=""
                                        />
                                      </span>
                                      <label className="blue">
                                        MY <br /> <strong>Profile</strong>
                                        <br></br>
                                      </label>
                                    </Link>
                                  </li>

                                  <li className="active">
                                    <div className="here-menu">
                                      <label>YOUR HERE</label>
                                      <img
                                        src="/assets/images/downround-icon.png"
                                        alt=""
                                      />
                                    </div>
                                    <Link to="">
                                      <span className="icon-wrap">
                                        <img
                                          src="\assets\images\icons\pro icon.png"
                                          alt=""
                                        />
                                      </span>
                                      <label className="red">
                                        <strong>goneet</strong>
                                        <br />
                                        <span
                                          style={{
                                            backgroundColor: "#283270",
                                            color: "white",
                                            padding: "2px",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          PRO
                                        </span>
                                      </label>
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="">
                                      <span className="icon-wrap">
                                        <img
                                          src="/assets/images/quick-links/network.svg"
                                          alt=""
                                        />
                                      </span>
                                      <label className="orange">
                                        MY
                                        <br />
                                        <strong>Network</strong> <br></br>
                                      </label>
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="">
                                      <span className="icon-wrap">
                                        <img
                                          src="/assets/images/quick-links/performance.svg"
                                          alt=""
                                        />
                                      </span>
                                      <label className="green">
                                        MY
                                        <br />
                                        <strong>Performance</strong> <br></br>
                                      </label>
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </UserLayout>
        </div>
      ) : (
        <div className="profile-analytics">
          <UserLayout>
            <img
              src="/assets/images/Pro_analytics.png"
              style={{ width: "100%" }}
            />
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={!paid}
            >
              <Modal.Body
                style={{ background: "#ECECEE", borderRadius: "10px" }}
              >
                <NewPayment id={props.user && props.user.id} />
              </Modal.Body>
            </Modal>
          </UserLayout>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const analytics = state.analytics.analytics;
  const profile = state.user.profile;
  const dashboard = state.dashboard.dashboard;
  const locationMap = state.network.locationMap;
  return {
    user: user,
    profile: profile,
    analytics: analytics,
    dashboard: dashboard,
    locationMap: locationMap,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchDashboard: () => dispatch(fetchDashboardAction()),
    fetchAnalytics: () => dispatch(fetchAnalyticsAction()),
    fetchMyLocation: (profileId) =>
      dispatch(fetchMyContactsLocationMapAction(profileId)),
    updatePaid: (id) => dispatch(updatePaidAction(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAnalytics);
